/**
 * WCAG 2.x relative luminance and contrast ratio, used to pick the launcher
 * icon color for whatever background the school chose.
 */

const HEX = /^#([0-9a-f]{6})$/i;

/** Falls back to the server default if the attribute is somehow not #rrggbb. */
export const FALLBACK_COLOR = '#1f2937';
export const LIGHT_INK = '#ffffff';
export const DARK_INK = '#111827';

export function normalizeHex(value: string | null | undefined): string {
  const v = (value || '').trim();
  return HEX.test(v) ? v.toLowerCase() : FALLBACK_COLOR;
}

function channel(c: number): number {
  const s = c / 255;
  return s <= 0.04045 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4);
}

export function luminance(hex: string): number {
  const n = parseInt(normalizeHex(hex).slice(1), 16);
  return (
    0.2126 * channel((n >> 16) & 255) +
    0.7152 * channel((n >> 8) & 255) +
    0.0722 * channel(n & 255)
  );
}

export function contrastRatio(a: string, b: string): number {
  const la = luminance(a);
  const lb = luminance(b);
  const [hi, lo] = la > lb ? [la, lb] : [lb, la];
  return (hi + 0.05) / (lo + 0.05);
}

/** White or near-black, whichever contrasts more with the background. */
export function inkFor(background: string): string {
  return contrastRatio(background, LIGHT_INK) >=
    contrastRatio(background, DARK_INK)
    ? LIGHT_INK
    : DARK_INK;
}
